export class ApplyOdCoFilter {
    type?:string
    constructor(type?:string) {
        this.type=type
    }
}